import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMastercard = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 32,
	viewBox: "0 0 48 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 4a4 4 0 0 1 4-4h40a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4z",
			fill: "#FDEACE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m29.009 6.527-10.33.036.314 18.91 10.329-.036-.313-18.91z",
			fill: "#FF5F00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.36 16.056a11.966 11.966 0 0 1 4.357-9.48c-2.037-1.599-4.59-2.56-7.359-2.55C9.8 4.048 4.584 9.45 4.694 16.106c.11 6.656 5.506 12.022 12.064 12 2.769-.01 5.29-.989 7.274-2.6-2.772-2.165-4.608-5.604-4.672-9.45z",
			fill: "#EB001B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.306 15.894c.11 6.655-5.106 12.058-11.664 12.08-2.768.01-5.322-.951-7.359-2.55 2.732-2.216 4.422-5.634 4.358-9.48a12.317 12.317 0 0 0-4.672-9.45 11.543 11.543 0 0 1 7.273-2.6c6.558-.022 11.954 5.378 12.064 12z",
			fill: "#F79E1B"
		})
	]
});
export default SvgMastercard;
